import { useEffect, useMemo, useState } from 'react';
const TBODY_ELEMENT_TYPE = 'TBODY';
const THEAD_ELEMENT_TYPE = 'THEAD';
const TR_ELEMENT_TYPE = 'TR';
export default function useCommentableAreaStyles({
  commentableArea,
  children
}) {
  const [isTableChild, setIsTableChild] = useState(false);
  useEffect(() => {
    if (!((commentableArea === null || commentableArea === void 0 ? void 0 : commentableArea.parentNode) instanceof HTMLElement)) {
      return;
    }
    const parentStyles = getComputedStyle(commentableArea === null || commentableArea === void 0 ? void 0 : commentableArea.parentNode);
    const inlineParentStyles = commentableArea === null || commentableArea === void 0 ? void 0 : commentableArea.parentNode.style;

    // Checks if parent is a table display to reapply table display to the
    // commentable area
    setIsTableChild(parentStyles.display === 'table' || inlineParentStyles && inlineParentStyles.display === 'table' || (commentableArea === null || commentableArea === void 0 ? void 0 : commentableArea.parentNode.nodeName) === TBODY_ELEMENT_TYPE || (commentableArea === null || commentableArea === void 0 ? void 0 : commentableArea.parentNode.nodeName) === THEAD_ELEMENT_TYPE);
  }, [commentableArea, children]);
  const isTr = useMemo(() => {
    if (commentableArea) {
      return commentableArea.nodeName === TR_ELEMENT_TYPE;
    }
    return false;
  }, [commentableArea]);
  return {
    isTableChild,
    isTr
  };
}